import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="E" transform="translate(11.000000, 5.000000)">
        <path
          d="M47.5,56.5 L33.5,56.5 L33.5,47.5 L44.5,47.5 L44.5,43.2 L33.5,43.2 L33.5,34.8 L47.5,34.8 L47.5,30.3 L28.5,30.3 L28.5,61 L47.5,61 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
